// extracted by mini-css-extract-plugin
export default {"base":"base-uxpSi","tab":"tab-hSrUF","activeTab":"activeTab-nqSzk tab-hSrUF","reverse":"reverse-wvfIv"};